module.exports = __webpack_public_path__ + "img/clove hitch.f53fa69b.jpg";